// react
// navigate
import { createSlice } from '@reduxjs/toolkit';
// formik
// @material-ui
// icons
// hooks
// @types
import { AxiosResponseModel } from '../../@types/base';
// redux
import { CONSTS } from './const';
import { dispatch } from '../store';
// routes
// components
// utils
import axios from '../../utils/axios';
// constants
import { HttpStatusCodes } from '../../constants/http-status-codes.enum';
import {
  AddEmployeeModel,
  AddOrSetEmployeeLocationRelationModel,
  AddOrSetEmployeeLocationRelationResultModel,
  EmployeeDetailListModel,
  EmployeeDetailModel,
  EmployeeListModel,
  EmployeeResultModel,
  GetAllEmployeeLocationRelationResultModel, GetEmployeeShiftWithReturnResponse,
  RemoveEmployeeLocationRelationModel, SetEmployeeShiftModel,
  UpdateEmployeeModel
} from '../../@types/employee';

// ----------------------------------------------------------------------

type EmployeeState = {
  employeeError: boolean;
  isEmployeeLoading: boolean;
  isEmployeeLocationRelationLoading: boolean;
  employeeLocationRelationError: boolean;
  employeeList: EmployeeDetailListModel[];
  employeeDetail: EmployeeDetailModel;
};

const employeeDetailInit: EmployeeDetailModel = {
  uuid: '',
  name: '',
  surname: '',
  identityNumber: '',
  department: '',
  companyId: 0,
  dateOfBirth: '',
  createdAt: '',
  updatedAt: '',
  employeeImages: []
  // status: '',
  // jobStartDate: ''
};

const initialState: EmployeeState = {
  employeeError: false,
  isEmployeeLoading: false,
  isEmployeeLocationRelationLoading: false,
  employeeLocationRelationError: false,
  employeeList: [],
  employeeDetail: employeeDetailInit
};

const slice = createSlice({
  name: 'employee',
  initialState,
  reducers: {
    // ----------------------------------------------------------------------
    // EMPLOYEE
    // ----------------------------------------------------------------------

    // START EMPLOYEE LOADING
    startEmployeeLoading(state) {
      state.isEmployeeLoading = true;
    },

    stopEmployeeLoading(state) {
      state.isEmployeeLoading = false;
    },

    isEmployeeLocationRelationLoadingReducer(state, action) {
      state.isEmployeeLocationRelationLoading = action.payload;
    },

    hasErrorEmployeeLocationRelation(state, action) {
      state.isEmployeeLocationRelationLoading = false;
      state.employeeLocationRelationError = action.payload;
    },

    // HAS ERROR EMPLOYEE
    hasErrorEmployee(state, action) {
      state.isEmployeeLoading = false;
      state.employeeError = action.payload;
    },

    // GET ALL EMPLOYEES
    getAllEmployeesSuccess(state, action) {
      state.isEmployeeLoading = false;
      state.employeeList = action.payload;
    },

    // GET EMPLOYEE DETAIL
    getEmployeeByIdSuccess(state, action) {
      state.isEmployeeLoading = false;
      state.employeeDetail = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const {} = slice.actions;

// ----------------------------------------------------------------------
// EMPLOYEE

export async function getAllEmployeesWithReturn(department: string = '') {
  dispatch(slice.actions.startEmployeeLoading());
  try {
    const url = department
      ? `${CONSTS.EMPLOYEE_GET_GET_ALL_EMPLOYEES}/${department}`
      : CONSTS.EMPLOYEE_GET_GET_ALL_EMPLOYEES;
    const response: AxiosResponseModel<EmployeeResultModel> = await axios
      .get(url)
      .catch((error) => {
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    if (response && response.status === HttpStatusCodes.StatusSuccess) {
      dispatch(slice.actions.getAllEmployeesSuccess(response.data?.data));
    } else {
      dispatch(slice.actions.getAllEmployeesSuccess([]));
    }
    return response;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorEmployee(error));
    return error.response.data;
  }
}

export function getEmployeeById(employeeUuid: string) {
  return async () => {
    dispatch(slice.actions.startEmployeeLoading());
    // dispatch(slice.actions.startDetailLoading());
    try {
      const response: AxiosResponseModel<EmployeeDetailModel> = await axios
        .get(`${CONSTS.EMPLOYEE_GET_GET_EMPLOYEE}/${employeeUuid}`)
        .catch((error) => {
          if (error.response) {
            return error.response.data;
          }
          return error;
        });
      if (response && response.status === HttpStatusCodes.StatusSuccess) {
        dispatch(
          slice.actions.getEmployeeByIdSuccess(
            response.data?.data || employeeDetailInit
          )
        );
      } else {
        dispatch(slice.actions.getEmployeeByIdSuccess(employeeDetailInit));
      }
    } catch (error: any) {
      dispatch(slice.actions.hasErrorEmployee(error));
    }
  };
}

export async function addEmployeeWithReturn(
  employee: AddEmployeeModel,
  fileUrls: string[],
  uuid: string
) {
  dispatch(slice.actions.startEmployeeLoading());
  try {
    employee.images = fileUrls;
    employee.uuid = uuid;
    const response: AxiosResponseModel<EmployeeResultModel> = await axios
      .post(CONSTS.EMPLOYEE_POST_ADD_EMPLOYEE, employee)
      .catch((error) => {
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    if (response && response.status === HttpStatusCodes.StatusSuccess) {
      // await getAllEmployeesWithReturn();
      dispatch(slice.actions.hasErrorEmployee(false));
    } else {
      dispatch(slice.actions.hasErrorEmployee(response.data?.message || ''));
    }
    return response;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorEmployee(error));
    return error.response.data;
  }
}

export async function updateEmployeeWithReturn(
  data: UpdateEmployeeModel,
  uuid: string
) {
  try {
    const response: AxiosResponseModel<null> = await axios
      .post(`${CONSTS.EMPLOYEE_POST_UPDATE_EMPLOYEE}/${uuid}`, data)
      .catch((error) => {
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    if (response && response.status === HttpStatusCodes.StatusSuccess) {
      // await getAllEmployeesWithReturn();
      dispatch(slice.actions.hasErrorEmployee(false));
    } else {
      dispatch(slice.actions.hasErrorEmployee(response.data?.message || ''));
    }
    return response;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorEmployee(error));
    return error.response.data;
  }
}


// export async function deleteEmployeeWithReturn(employeeIds: string[]) {
//   // dispatch(slice.actions.startCompanyLoading());
//   try {
//     const response: AxiosResponseModel<null> = await axios
//       .delete(`${CONSTS.EMPLOYEE_DELETE_DELETE_EMPLOYEE}/${employeeIds[0]}`)
//       .catch((error) => {
//         if (error.response) {
//           return error.response.data;
//         }
//         return error;
//       });
//     return response;
//   } catch (error: any) {
//     dispatch(slice.actions.hasErrorEmployee(error));
//     return error.response.data;
//   }
// }


// export async function updateEmployeeWithReturn(
//   employee: AddEmployeeModel,
//   fileUrls: string[],
//   uuid: string
// ) {
//   dispatch(slice.actions.startEmployeeLoading());
//   try {
//     employee.images = fileUrls;
//     employee.uuid = uuid;
//     const response: AxiosResponseModel<EmployeeResultModel> = await axios
//       .post(CONSTS.EMPLOYEE_POST_UPDATE_EMPLOYEE, employee)
//       .catch((error) => {
//         if (error.response) {
//           return error.response.data;
//         }
//         return error;
//       });
//     if (response && response.status === HttpStatusCodes.StatusSuccess) {
//       // await getAllEmployeesWithReturn();
//       dispatch(slice.actions.hasErrorEmployee(false));
//     } else {
//       dispatch(slice.actions.hasErrorEmployee(response.data?.message || ''));
//     }
//     return response;
//   } catch (error: any) {
//     dispatch(slice.actions.hasErrorEmployee(error));
//     return error.response.data;
//   }
// }

export async function deleteEmployee(employeeUuid: string) {
  dispatch(slice.actions.startEmployeeLoading());
  try {
    const response: AxiosResponseModel<null> = await axios
      .delete(`${CONSTS.EMPLOYEE_DELETE_DELETE_EMPLOYEE}/${employeeUuid}`)
      .catch((error) => {
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    dispatch(slice.actions.stopEmployeeLoading());
    return response;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorEmployee(error));
    return error.response.data;
  }
}

export async function addOrSetLocationRelationsWithReturn(data: AddOrSetEmployeeLocationRelationModel) {
  dispatch(slice.actions.isEmployeeLocationRelationLoadingReducer(true));
  try {
    const response: AxiosResponseModel<AddOrSetEmployeeLocationRelationResultModel> = await axios
      .post(CONSTS.EMPLOYEE_POST_ADD_OR_SET_LOCATION_RELATION, data)
      .catch((error) => {
        dispatch(slice.actions.hasErrorEmployeeLocationRelation(true));
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    dispatch(slice.actions.isEmployeeLocationRelationLoadingReducer(false));
    return response;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorEmployee(error));
    return error.response.data;
  }
}

export async function removeLocationRelationsWithReturn(data: RemoveEmployeeLocationRelationModel) {
  dispatch(slice.actions.isEmployeeLocationRelationLoadingReducer(true));
  try {
    const response: AxiosResponseModel<null> = await axios
      .post(CONSTS.EMPLOYEE_POST_REMOVE_LOCATION_RELATION, data)
      .catch((error) => {
        dispatch(slice.actions.hasErrorEmployeeLocationRelation(true));
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    dispatch(slice.actions.isEmployeeLocationRelationLoadingReducer(false));
    return response;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorEmployee(error));
    return error.response.data;
  }
}

export async function getAllEmployeeLocationRelationsWithReturn(employeeUuid: string) {
  dispatch(slice.actions.isEmployeeLocationRelationLoadingReducer(true));
  try {
    const response: AxiosResponseModel<GetAllEmployeeLocationRelationResultModel[]> = await axios
      .get(`${CONSTS.EMPLOYEE_GET_GET_ALL_LOCATION_RELATIONS}/${employeeUuid}`)
      .catch((error) => {
        dispatch(slice.actions.hasErrorEmployeeLocationRelation(true));
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    dispatch(slice.actions.isEmployeeLocationRelationLoadingReducer(false));
    return response;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorEmployee(error));
    return error.response.data;
  }
}


export async function getEmployeeShiftWithReturn(uuid: string){
  try {
    const response: AxiosResponseModel<GetEmployeeShiftWithReturnResponse> = await axios
      .get(`${CONSTS.EMPLOYEE_GET_GET_EMPLOYEE_SHIFT}/${uuid}`)
      .catch((error) => {
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    dispatch(slice.actions.stopEmployeeLoading());
    return response.data;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorEmployee(error));
    return error.response.data;
  }
}

export async function setEmployeeShiftWithReturn(uuid: string, data: SetEmployeeShiftModel){
  try {
    const response: AxiosResponseModel<null> = await axios
      .post(`${CONSTS.EMPLOYEE_POST_SET_EMPLOYEE_SHIFT}/${uuid}`, data)
      .catch((error) => {
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    dispatch(slice.actions.stopEmployeeLoading());
    return response;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorEmployee(error));
    return error.response.data;
  }
}